import { API_ROOT } from '../../config/config'
import { doDownload, doGet, doPost, doPostFiles } from './utils'

// const API_ROOT = 'http://localhost:80/api'

export const getFinancialReport = (
  period = 0,
  projectCode = null,
  projectVersionId = null,
  installmentPlanDetailId
) => {
  ///http://localhost/api/subproject/subproject-financial-report/page/388FF75D-5F59-418C-B4AD-7382CDF453E7?period=111&projectCode=222&projectVersionId=33

  const url = `${API_ROOT}/subproject/subproject-financial-report/page/${installmentPlanDetailId}?period=${period}&projectCode=${projectCode}&projectVersionId=${projectVersionId}`
  return doGet(url)
}

export const saveWithdrawBankAccAmt = (request) => {
  // /api/subproject/subproject-progress-report/save-withdraw-bank-account-amt
  const url = `${API_ROOT}/subproject/subproject-progress-report/save-withdraw-bank-account-amt`
  return doPost(url, request)
}

export const saveFinancialReport = (request) => {
  // /api/subproject/subproject-progress-report/save-financialreport
  const url = `${API_ROOT}/subproject/subproject-progress-report/save-financialreport`
  return doPostFiles(url, request)
}

export const getDowloadSubProjectFilePath = (filePath) => {
  // /subproject/download/file?filePath=www
  const url = `${API_ROOT}/subproject/download/file?filePath=${filePath}`
  return doDownload(url)
}

export const saveFinancialReportSendBlack = (request) => {
  // http://103.91.191.229:9000/api/subproject/subproject-progress-report/send-back-for-correction
  const url = `${API_ROOT}/subproject/subproject-progress-report/send-back-for-correction`
  return doPost(url, request)
}

export const saveTransferInstallmentPayment = (request) => {
  // http://103.91.191.229:9000/api/subproject/subproject-progress-report/transfer-installment-payment
  const url = `${API_ROOT}/subproject/subproject-progress-report/transfer-installment-payment`
  return doPostFiles(url, request)
}

export const saveRequestingDisbursement = (request) => {
  // http://103.91.191.229:9000/api/subproject/subproject-progress-report/submit-report-requesting-disbursement
  const url = `${API_ROOT}/subproject/subproject-progress-report/submit-report-requesting-disbursement`
  return doPostFiles(url, request)
}

export const saveApproveInstallmentDisbursement = (request) => {
  // http://103.91.191.229:9000/api/subproject/subproject-progress-report/approve-installment-disbursement
  const url = `${API_ROOT}/subproject/subproject-progress-report/approve-installment-disbursement`
  return doPost(url, request)
}

export const getProgressFinancialPdf = (projectCode, period) => {
  // http://localhost/api/files/subproject/65-10142-10/2/progress-financial/manager/form

  const url = `${API_ROOT}/files/subproject/${projectCode}/${period}/progress-financial/manager/form`
  return doDownload(url)
}

export const getProgressReportPdf = (projectCode, period, isFinalReport) => {
  const url = `${API_ROOT}/files/subproject/${projectCode}/${period}/${isFinalReport}/progress-period/manager/form`
  return doDownload(url)
}